import { useState } from 'react';
import { AlertWindow } from '../components/AlertWindow';

export const useAlert = () => {
  const [alert, setAlert] = useState<{
    message: string;
    type?: 'info' | 'success' | 'warning' | 'error';
    title?: string;
  } | null>(null);

  const showAlert = (
    message: string,
    options: {
      type?: 'info' | 'success' | 'warning' | 'error';
      title?: string;
    } = {}
  ) => {
    setAlert({ message, ...options });
  };

  const dismissAlert = () => {
    setAlert(null);
  };

  const AlertComponent = alert ? (
    <AlertWindow
      message={alert.message}
      type={alert.type}
      title={alert.title}
      onDismiss={dismissAlert}
    />
  ) : null;

  return { showAlert, AlertComponent };
};
